import React from "react";
import { useSelector } from "react-redux";
import { Row, Col, Card, CardHeader, CardBody, Button } from "reactstrap";
import CartItem from "./cartItem";
import { deleteFromCart } from "../../actions/newCartActions";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import { withRouter } from "react-router-dom";

function NewCart({ currency, history }) {
  const cart = useSelector((state) => state.newCartReducer);
  const dispatch = useDispatch();

  const handleDeleteFromCart = (cartItem) => {
    dispatch(deleteFromCart(cartItem.fortnoxNumber));
  };

  const getFormattedPrice = (price) => {
    if (!currency) {
      return `${price} kr`;
    }
    return currency === "SEK" ? `${price} kr` : `${price} ${currency}`;
  };

  const totalAmount = () => {
    return cart.result.reduce((acum, item) => {
      acum += item.priceStudent * item.addedStudents.length;
      return acum;
    }, 0);
  };
  const handleCheckIfIsLastAdded = (cartItem) => {
    if (cart.lastAddedItem.isPlusPackage) {
      if (
        cart.lastAddedItem.studentLicense.fortnoxNumber ===
          cartItem.fortnoxNumber ||
        cart.lastAddedItem.plusPackage.fortnoxNumber === cartItem.fortnoxNumber
      )
        return true;
    } else {
      if (cart.lastAddedItem.fortnoxNumber === cartItem.fortnoxNumber) {
        return true;
      }
    }
    return false;
  };
  const buildCartList = () => {
    return cart.result.map((cartItem, i) => {
      return (
        <CartItem
          key={i}
          cartItem={cartItem}
          readonly={false}
          handleDeleteFromCart={() => handleDeleteFromCart(cartItem)}
          isLatestAdded={handleCheckIfIsLastAdded(cartItem)}
        />
      );
    });
  };

  const buildCart = () => {
    return (
      <div style={{ margin: "10px" }}>
        <Card>
          <CardHeader>
            <h5 className="mb-0">
              <FormattedMessage id="MyCart" />
            </h5>
          </CardHeader>

          <CardBody>{buildCartList()}</CardBody>
        </Card>
      </div>
    );
  };

  const buildCartTotal = () => {
    return (
      <div style={{ margin: "10px" }}>
        <Card>
          <Row>
            <Col>
              <div
                className="float-end pt-1 "
                style={{ marginRight: "15px", paddingBottom: ".3rem" }}
              >
                {" "}
                <h5 style={{ marginTop: "8px" }}>
                  <FormattedMessage id="TotalCost" />:{" "}
                  {getFormattedPrice(totalAmount())}
                </h5>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {cart.result.length > 0 ? (
                <div
                  className="float-end"
                  style={{ paddingBottom: "1.05rem", paddingRight: ".9rem" }}
                >
                  <Button
                    disabled={
                      !cart.result.some((item) => item.addedStudents.length > 0)
                    }
                    outline
                    color="primary"
                    onClick={() => history.push("/teacher/shop/confirmedorder")}
                  >
                    <FormattedMessage id="GoToCheckout" />
                  </Button>
                </div>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </Card>
      </div>
    );
  };

  return (
    <>
      {cart.result.length !== 0 ? (
        <aside className="cart">
          {buildCart()}
          {buildCartTotal()}
        </aside>
      ) : (
        <aside className="empty-cart">
          <FormattedMessage id="YourCartIsEmpty" />
        </aside>
      )}
    </>
  );
}

export default withRouter(NewCart);
